"use client";
import React, { useState } from "react";
import Select from "react-select";
import { cn } from "@/lib/utils";

const ReactSelect = ({
  options,
  label,
  errorMessage,
  isInvalid,
  className,
  field, // Accept field from react-hook-form
}) => {
  const [isFocused, setIsFocused] = useState(false);

  const customStyles = {
    control: (provided, state) => ({
      ...provided,
      borderColor: isInvalid ? "#dc2626" : state.isFocused ? "#3b82f6" : "#d1d5db",
      boxShadow: state.isFocused ? "0 0 0 1px #3b82f6" : "none",
      borderRadius: "0.375rem",
      padding: "4px",
      minHeight: "50px",
      fontSize: "14px",
      "&:hover": {
        borderColor: isInvalid ? "#dc2626" : "#9ca3af",
      },
    }),
    menu: (provided) => ({
      ...provided,
      borderRadius: "0.375rem",
      boxShadow: "0px 4px 6px #d1d5db",
      fontSize: "14px",
      zIndex:"2"
    }),
    option: (provided, state) => ({
      ...provided,
      backgroundColor: state.isFocused ? "#f3f4f6" : "white",
      color: "#111827",
      padding: "0.5rem 1rem",
      cursor: "pointer",
      fontSize: "14px",
    }),
    singleValue: (provided) => ({
      ...provided,
      color: "#111827",
    }),
  };

  return (
    <div className={cn(
      ["Role*", "Country*", "Store location*"].includes(label) ? "relative w-full mb-5" : "relative w-full",
      isInvalid && "border-red-500 focus:border-red-500"
    )}>

      {/* Floating Label */}
      <label
        className={`absolute left-3 z-[1] text-[14px]  transform -translate-y-1/2 text-gray-500 transition-all pointer-events-none ${
          isFocused || field.value ? "top-0 bg-white px-[2px]" : "top-1/2"
        }`}
      >
        {label}
      </label>

      {/* React-Select Component */}
      <Select
        {...field} // ✅ Spread field props from react-hook-form
        options={options}
        value={options?.find((opt) => opt.value === field.value) || null} // ✅ Ensure proper reset
        onChange={(selectedOption) => field.onChange(selectedOption ? selectedOption.value : "")} // ✅ Reset to empty value
        onFocus={() => setIsFocused(true)}
        onBlur={() => setIsFocused(false)}
        classNamePrefix="react-select"
        className="mt-1"
        placeholder=""
        styles={customStyles}
      />
      {/* <Select
        {...field} // Pass react-hook-form field props
        options={options}
        value={options?.find((opt) => opt.value === field.value)} // Ensure proper value binding
        onChange={(selectedOption) => field.onChange(selectedOption.value)} // Store only value
        onFocus={() => setIsFocused(true)}
        onBlur={() => setIsFocused(false)}
        classNamePrefix="react-select"
        className="mt-1"
        placeholder=""
        styles={customStyles}
      /> */}

      {/* Error Message */}
      {isInvalid && (
        <p className="text-red-600 text-[10px] absolute bottom-[-18px] left-[12px]">
          {errorMessage}
        </p>
      )}
    </div>
  );
};

export default ReactSelect;